<template>
  <div>
    Tracking Orders
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: 'TrackingOrders',
  data: () => ({
    role: 1
  }),

  computed: {
  },
  mounted () {

  },
  methods: {
  },
  components: {    
  },
};
</script>
